var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVirtual = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 8.169c0-1.06.859-1.919 1.919-1.919h14.71c1.06 0 1.919.859 1.919 1.919v1.638l3.204-1.972a1.92 1.92 0 0 1 2.925 1.635v10.56a1.921 1.921 0 0 1-2.925 1.635l-3.204-1.972v1.638c0 1.06-.859 1.919-1.919 1.919H4.169a1.919 1.919 0 0 1-1.919-1.919V8.17z",
  fill: "#6CC049"
})));
export default SvgVirtual;